export const stepperfield = {
  flexDirection: { value: 'column' },
  input: {
    textAlign: { value: 'center' },
  },
};
